import { render, staticRenderFns } from "./ReductModal.vue?vue&type=template&id=c9fd2508&"
import script from "./ReductModal.vue?vue&type=script&lang=js&"
export * from "./ReductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports